import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.6 5.276a.3.3 0 0 0-.455-.257l-3.69 2.23H5.2a.8.8 0 0 0-.8.8v2.653a.8.8 0 0 0 .8.8h6.255l3.69 2.228a.3.3 0 0 0 .455-.256zm-1.179-1.455C15.554 3.137 17 3.952 17 5.276v8.198c0 1.323-1.446 2.14-2.579 1.455l-3.356-2.027H5.2a2.2 2.2 0 0 1-2.2-2.2V8.048a2.2 2.2 0 0 1 2.2-2.2h5.865z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.295 12.637V6.765h1.4v5.872zM6.243 15.42l-1.515-3.13 1.26-.61 1.514 3.129a.385.385 0 0 0 .696-.331l-.818-1.752 1.268-.593.818 1.752a1.786 1.786 0 0 1-3.223 1.534",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=MegaphoneIcon20.js.map